import React from 'react';

function Blog05() {
	return (
		<div className='blogwrap'>
			<div className='blog-head'>What Now?</div>

			<div className='blog-head2'>Blog 2 / 2</div>
			<div className='blog-author'>by: C.Robs (9/14/2026)</div>
			<div className='blog-body'>
				<div className='blog-line'>
					So what is this? I don't know. Right now, it's a way to keep my brain
					active and my fingers doing something during my down time. I like
					writing and I've never done much of it publically outside of angry
					instagram posts defending the Denver Broncos. Since I like music and
					love showing people new bands, this felt like a good combination to
					satisfy several desires. I have some ideas for now, but everything is
					fairly fluid and depends on if anyone starts to follow or read this. I
					mean, who reads blogs? For now, I plan to bank up some old and new
					artists alike from all different genres. There's currently no
					limitation to what I want to post, talk about, or share with people. I
					like electronic music, alternative music, punk rock, metal, whatever.
					Another plan is to create several playlists and to attach these to
					certain posts. For instance, if I want to write about the movement of
					underground chemical house in Berlin, I'll make a playlist to show
					some of the songs I enjoy from that scene. If I write a blog
					specifically about a band, maybe I'll make a small playlist of my
					favorites from them as well as some songs from similar bands.
				</div>
				<div className='blog-line'>
					As of now, I have this website you somehow stumbled on and an
					Instagram page. As/If this evolves, I will find a convenitent way to
					share my links and anything else people might want to follow. On top
					of this, I would love to hear stories, blog ideas, music, or whatever
					from all of you. If you have a fun article about a festival you went
					to and want to share, send it over and maybe I'll post it on here. I
					want this website to express the intrests of many different people
					rather than just my own. Maybe one day, there could be different
					authors who consistently post and share their music tastes. If someone
					likes doing websites or running social media, I'd also be very
					interested in sharing the load. Like I said, it's fluid. We're just
					moving along.
				</div>
				<div className='blog-line'>
					I feel the need to bring this up, though it currently feels like the
					"cuss word" of creatives. To me, AI is a tool. It's not the means to
					and end product. I do not want to talk about AI anymore than I already
					have. It should be used to make life convenient, organize files, etc.
					It's not a way to make music in my personal opinion. There's no doubt
					that it's quickly getting integrated in the music and art scene
					heavily, but I do not want to listen to any sort of AI generated
					sounds, look at AI generated slop, and would rather have a bare bones,
					black and white website than use AI to razzle-dazzle this page. I am
					also not perfect and it can be extremely hard to diffrentiate from
					what's AI and what isn't. so I'd like to know if something slips in
					the future and I share a song or picture that might be generated by
					anything not human. I have already unfollowed and stopped listening to
					songs I enjoyed due to the high possibility of them being AI and plan
					to continue to do so. That's the end of that and the last time I even
					want to use the word AI.
				</div>
				<div className='blog-line'>
					Anyone will daydream about some crazy, future plan they have with a
					business they create or headlining a show with a band they put
					together. I could go on about the dreams I'd have with putting on a
					successful music blog/organization, but for now, it's me and a
					keyboard. I'm inspired by the old blog "ThisSongIsSick", which put
					thousands of Colorado kids onto so many different electronic artists
					back in the late 2000s, early 2010s. From blogs to shows, it seemed
					like that website was one of the most important pieces of that era of
					EDM, especially in Colorado. By the end, it seemed like the goal
					switched from sharing new artists to making money. I want to be clear,
					my core value with this website is to share and create community. I
					don't want another "pay for promo" playlist with a hundred half-baked
					songs from kids with money. I want to share and listen to good music.
					I want to talk about new and local bands. I want to meet like minded
					people in the music industry.
				</div>
				<div className='blog-line'>
					Hopefully, this makes any intentions I have clear and where I stand on
					certain topics. For now, I can promise you these few things: spelling
					errors, gramatical errors, inconsistent posts, and opinions that no
					one asked for. If that sounds like a good time to you, then go ahead
					and follow along. If not, whatever. So, let's actually get into
					sharing some music!
				</div>
				-C.Robs
			</div>
		</div>
	);
}

export default Blog05;
